import { render, staticRenderFns } from "./myCreate.vue?vue&type=template&id=6046dfa3&scoped=true"
import script from "./myCreate.vue?vue&type=script&lang=js"
export * from "./myCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6046dfa3",
  null
  
)

export default component.exports